// src/components/ProjectHistoryDataGridColumns.js

export const logColumns = [
  {
    field: 'createdAt',
    headerName: 'Timestamp',
    width: 170,
    valueGetter: (params) => new Date(params.row.createdAt).toLocaleString(),
  },
  {
    field: 'type',
    headerName: 'Log Type',
    width: 75,
  },
  {
    field: 'category',
    headerName: 'Category',
    width: 160,
  },
  {
    field: 'entityId',
    headerName: 'Entity',
    width: 150,
  },
  {
    field: 'modelType',
    headerName: 'Type',
    width: 90,
  },
  {
    field: 'description',
    headerName: 'Description',
    width: 400,
    renderCell: (params) => <div>{params.value}</div>, // Render the log description as plain text
  },
  {
    field: 'source',
    headerName: 'Source',
    width: 200,
  },
  {
    field: 'owner',
    headerName: 'Owner',
    width: 150,
  },
];
